module.exports = __webpack_public_path__ + "media/localization/italian-7ee1b70d.png";